import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PromotionModalComponent } from './promotion.component';

@Injectable({
	providedIn: 'root',
})
export class PromotionModalService {
	private _modalRef: NgbModalRef | undefined;

	constructor(private _modal: NgbModal) {}

	public open(): void {
		this._modalRef = this._modal.open(PromotionModalComponent, {
			size: 'lg',
			windowClass: 'promotion-modal',
		});
	}
}
